module.exports = __webpack_public_path__ + "static/img/bgi.3a445f74.jpg";